var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"font-weight-bold text-dark font-size-24"},[_vm._v("$78.62M")]),_c('div',[_vm._v("Paid in Crypto")]),_c('vue-chartist',{staticClass:"height-200 ct-hidden-points",attrs:{"type":"Line","data":_vm.data,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }